import React, { useEffect, useState, useRef } from "react";
import { collection, getDocs } from "firebase/firestore";
import "./CarouselProduct.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const CarouselProduct = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const carouselRef = useRef(null); // Ref for carousel container

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const productsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productsData);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  const handleViewProduct = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <div className="caarousel">
      <button className="sscroll-btn left" onClick={scrollLeft}>
      <FaArrowLeft />
      </button>
      <div ref={carouselRef} className="caarousel-container">
        {products.map((product) => (
          <div key={product.id}
          onClick={() => handleViewProduct(product.id)} className="caarousel-item">
            <img
              src={product.imageUrl}
              alt={product.name}
              className="caarousel-item-image"
            />
            <h3 className="caarousel-item-title">{product.name}</h3>
            <p className="pricee">₦{product.price}.00</p>
          </div>
        ))}
      </div>
      <button className="sscroll-btn right" onClick={scrollRight}>
      <FaArrowRight />
      </button>
    </div>
  );
};

export default CarouselProduct;
